<template>
    <b-card header="Claims Submissions"
            header-text-variant="white"
            header-bg-variant="info">
        
            <b-card-group deck class="mb-3">
                <b-card class="text-center">
                    <canvas id="Sent" width="200" height="100"></canvas><br>
                    Number of Claims Sent: {{ this.sentItems.length }}
                </b-card>
                <b-card class="text-center">
                    <canvas id="Accepted" width="200" height="100"></canvas><br>
                    Number of Claims Accepted: {{ this.acceptedItems.length }}
                </b-card>
                <b-card class="text-center">
                    <canvas id="Rejected" width="200" height="100"></canvas><br>
                    Number of Claims Rejected: {{ this.rejectedItems.length }}
                </b-card>
            </b-card-group>
        
        <b-row class="mb-3">

            <b-col>

                <b-button-toolbar aria-label="Toolbar with button groups and input groups">

                    <b-input-group size="sm" class="m-1" left="Date Range">

                        <date-picker v-model="start_date" placeholder="Start Date" class="w-50" :disabled="loading" />
                        <date-picker v-model="end_date" placeholder="End Date" class="w-50" :disabled="loading" />
                    </b-input-group>
                    <b-input-group size="sm" class="m-1" left="Claimant">

                        <b-form-select v-model="client_id" class="" :disabled="loading">

                            <option value="">All Claimants</option>
                            <option v-for="item in clients" :value="item.id" :key="item.id">{{ item.nameLastFirst }}</option>
                        </b-form-select>
                    </b-input-group>
                    <b-input-group size="sm" class="m-1" left="Carrier">

                        <carrier-parents-dropdown v-model=" parent_carrier "></carrier-parents-dropdown>
                    </b-input-group>
                    <b-input-group size="sm" class="m-1" left="Block">

                        <carrier-dropdown v-model=" carrier " :disabled="loading"></carrier-dropdown>
                    </b-input-group>
                </b-button-toolbar>
            </b-col>
        </b-row>

        <div class="table-responsive">
            <b-row>
                <b-col class="text-right mb-3">
                    <b-btn variant="success" :href="url + '&export=1'" :disabled="loading">
                        <i class="fa fa-file-excel-o"></i> Export to Excel
                    </b-btn>
                    <b-btn variant="info" @click="reload()" :disabled="loading">Generate</b-btn>
                </b-col>
            </b-row>

            <loading-card v-if="loading" />

            <b-table :items="items" :fields="fields" v-else>
              <template v-slot:cell(submission_status)="data">
                  <b-btn
                      block
                      :style="statusClass('Accepted')"
                      variant="white"
                  >
                      Accepted
                  </b-btn>
              </template>
              <template v-slot:cell(submitted_at)="row">
                <utc-time :role="role" :time="row.item.submitted_at" format="MM/DD/YYYY h:mm A zz" />
              </template>
            </b-table>
        </div>
    </b-card>
</template>

<script>

    import FormatsNumbers from '../../mixins/FormatsNumbers'
    import HasCarrierDropdowns from '../../mixins/HasCarrierDropdowns';

    export default {

        props: {
          role: {
            type: String,
            required: false,
            default: '',
          },
          clients: {
            type: Array,
            default: () => [],
          }
        },

        mixins: [ FormatsNumbers, HasCarrierDropdowns],

        data() {

            return {

                loading        : false,
                end_date       : moment(new Date()).format('MM/DD/YYYY'),
                start_date     : moment(new Date()).subtract(14, 'days').format('MM/DD/YYYY'),
                client_id      : '',
                items          : [],
                fields: [
                    { sortable: true, key: 'submitted_at', label: 'Date Submitted', formatter: x => this.formatDate(x) },
                    // time: { sortable: true },
                    {  sortable: true, key: 'client_name', label: 'Claimant' },
                    { key: 'carrier', sortable: true, },
                    { key: 'hours', sortable: true }, 
                    { key: 'amount', sortable: true, formatter: x => this.moneyFormat(x) }, 
                    // evv_type: { sortable: true }, 
                    // verified: { sortable: true }, 
                    { key: 'submission_status', sortable: true },
                ]
            }
        },

        computed: {

            url() {

                return '/business/reports/claims-submissions?json=1&start_date=' + this.start_date + '&end_date=' + this.end_date + '&client_id=' + this.client_id + `&carrier=${this.carrier_query_string}`;
            },
            sentItems() {
                return this.items;
            },
            acceptedItems() {
                return this.items;
            },
            rejectedItems() {
                return [];
            }  
        },

        methods: {

            reload() {
                this.loading = true;

                axios.get(this.url)
                    .then( ({ data }) => {
                        this.items = Array.isArray(data) ? data : [];
                        this.createCharts();
                        this.loading = false;
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            },

            formatDate(date) {
                return moment.utc(date).local().format('L LT');
            },

            statusClass(value) {
                if (value == 'Sent') return { border: '2px solid orange' }
                if (value == 'Accepted') return { border: '2px solid green' }
                if (value == 'Rejected') return { border: '2px solid red' }
                return {}
            },

            createCharts() {
                let statuses = [
                    { label: 'Sent', color: 'orange', items: this.sentItems },
                    { label: 'Accepted', color: 'green', items: this.acceptedItems },
                    { label: 'Rejected', color: 'red', items: this.rejectedItems },
                ];
                
                statuses.forEach((status) => {
                    var ctx = document.getElementById(status.label).getContext('2d');
                    var myChart = new Chart(ctx, {
                        type: 'doughnut',
                        data: {
                            labels: [`Claims ${status.label}`, 'Claims'],
                            datasets: [{
                                data: [status.items.length, this.items.length],
                                backgroundColor: [
                                    status.color,
                                    'lightgray',
                                ],
                                borderWidth: 1
                            }]
                        }
                    });
                })
            },
        },

        mounted() {

        }
    }
</script>

<style scoped>
    .input-group .form-control {
        min-width: 120px;
    }
    .datepicker {
        z-index: 40 !important;
    }
</style>